import { confirmable } from 'react-confirm'
import styled from 'styled-components'
import Icon from '@/components/icon'
import { breakpoints, colors, fontWeights } from '@/styles'
import BaseDialog from './base'

const ModalTitle = styled.h1`
  color: ${colors.regular};
  text-align: center;
  font-weight: ${fontWeights.bold};
  font-size: 26px;
  letter-spacing: -0.2px;
  line-height: 36px;
  margin: 28px 0 8px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 24px;
    letter-spacing: -0.4px;
    line-height: 32px;
  }
`

const ModalText = styled.p`
  color: ${colors.mediumGrey};
  font-size: 16px;
  letter-spacing: -0.2px;
  line-height: 24px;
  text-align: center;
  margin: 0 0 32px;
`

const isDisabled = () => false

const Confirmation = ({ title, messages, icon = 'warning', ...rest }) => (
  <BaseDialog {...rest} isDisabled={isDisabled}>
    <Icon id={icon} width={73} height={73} />
    <ModalTitle>{title}</ModalTitle>
    {messages.map((message, index) => (
      <ModalText key={index}>{message}</ModalText>
    ))}
  </BaseDialog>
)

export default confirmable(Confirmation)
